import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { StepperProps } from './models';

const Progress = styled.div`
  ${styles.Progress}
`;

export const Stepper = styled(
  memo(({ className, steps, currentStepPosition, currentStepProgress }: StepperProps) => {
    const stepsList = useMemo(() => {
      const sortPositions = (a, b) => a.position - b.position;
      return steps?.sort(sortPositions).map(({ position, title }) => {
        let progress = 0;
        if (position < currentStepPosition) {
          progress = 100;
        } else if (position === currentStepPosition) {
          progress = currentStepProgress || 100;
        }

        return (
          <div {...{ className: 'step-wrapper', key: position }}>
            <Progress {...{ progress }} />
            {position === currentStepPosition && <p className="title">{title}</p>}
          </div>
        );
      });
    }, [currentStepPosition, steps]);

    return (
      <div {...{ className }}>
        <div className="steps-wrapper">{stepsList}</div>
      </div>
    );
  })
)`
  ${styles.Stepper}
`;

export type { Step } from './models';
